import { LICENSED_PRODUCTS } from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';
import { useLicensedProducts } from '@atlassian/jira-tenant-context-controller/src/components/licensed-products/index.tsx';

export const useTenantHasConfluence = () => {
	const licensedProducts = useLicensedProducts();

	return Boolean(licensedProducts[LICENSED_PRODUCTS.CONFLUENCE]);
};
